<label class="checkbox-label" [for]="textId">
  <input
    type="checkbox"
    [id]="textId"
    [required]="isRequired"
    [checked]="isChecked"
    (change)="onCheckboxChange($event)"
  />
  {{ labelText }}
</label>
